import { PropTypes, Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import {DeviceScreen} from "../utils/Constant";
import {fontUnit} from "../utils/DeviceManager";
import {AcnColorTheme} from "../assets/css/AcnColorTheme";
interface DynamicTitleProps {
    title: string;
    size?: number;
    color?: string;
    align?: PropTypes.Alignment;
    isFull?: boolean;
    paddingTop?: number;
    isContent?: boolean;
    isFontWeightMediumStyle?: boolean;
}
function DynamicTitle(props: DynamicTitleProps) {
    const { title, size, color, align = "center", paddingTop = 0 } = props;
    const [screenView] = useSelector((state: RootState) => [
        state.deviceReducer.screenView
    ]);
    const useStyles = makeStyles((theme: Theme) => ({
        textTitle: {
            fontFamily: props.isFontWeightMediumStyle ? 'Prompt-Medium !important' : 'Prompt !important',
            margin: 0,
            paddingTop: paddingTop? paddingTop: 0,
            color: color ? color : AcnColorTheme.darkBlue,
            fontWeight:  props.isFontWeightMediumStyle ? 600 :1000,
            //              RIGHT           LEFT                BOTTOM          TOP            RIGHT BOTTOM       LEFT TOP           RIGHT TOP            LEFT BOTTOM               LEFT BOTTOM
            // textShadow: "3.5px 0 0 #101B2A, -2px 0 0 #101B2A, 0 3px 0 #101B2A, 0 -2px 0 #101B2A, 3.5px 3px #101B2A, -2px -2px 0 #101B2A, 2px -2px 0 #101B2A, 0px 3px 0 #101B2A, -2px 2px 0 #101B2A",
            textAlign: "center",
            whiteSpace: 'pre-line'


        },
        textTitleDesktop: {
            fontSize: size ? size : fontUnit(60),
            lineHeight: props.isContent ? '45px' :'70px',
            paddingLeft: props.isFull ? "0%" : "27%",
            paddingRight: props.isFull ? "0%" : "27%"
        },
        textTitleTablet: {
            fontSize: size ? size : fontUnit(60),
            lineHeight: size ? `${size+5}px` :  '70px',
            paddingLeft: props.isFull ? "0%" : "5%",
            paddingRight: props.isFull ? "0%" : "5%",
        },
        textTitleMobile: {
            fontSize: size ? size : fontUnit(60),
            lineHeight: size ? `${size+5}px` :  '50px',
            paddingLeft: props.isFull ? "0%" : "5%",
            paddingRight: props.isFull ? "0%" : "5%",
        },
        alignLeft: {
            paddingLeft: 0,
            paddingRight: 0,
            textAlign: "left"
        },
        alignRight: {
            paddingRight: 0,
            paddingLeft: 0,
            textAlign: "right"
        },
        divMobile: {
            position: "relative",
        },
        divDesktop: {
            position: "relative",
            paddingTop: "16px",
        },
        divTablet: {
            position: "relative",
            paddingTop: "16px",
        }
    }));
    const classes = useStyles();
    return (
        <div className={clsx(screenView === DeviceScreen.MOBILE && classes.divMobile, screenView === DeviceScreen.DESKTOP && classes.divDesktop, screenView === DeviceScreen.TABLET && classes.divTablet)}>
            <Typography align={align}
                        className={clsx(classes.textTitle, screenView === DeviceScreen.MOBILE && classes.textTitleMobile,
                            screenView === DeviceScreen.TABLET && classes.textTitleTablet,
                            screenView === DeviceScreen.DESKTOP && classes.textTitleDesktop,
                            { [classes.alignLeft]: align === "left", [classes.alignRight]: align === "right" })}>
                {title}
            </Typography>
        </div>
    );
}
export default DynamicTitle;